import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import TopTabbar from "../partials/TopTabbar";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import BankService from '../../services/BankService';
import 'react-toastify/dist/ReactToastify.css';
import Flags from "react-world-flags";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import LoadingSpinner from '../../utils/LoadingSpinner';

const countries = [
    { code: "CM", name: "Cameroun" },
    { code: "CA", name: "Canada" },
    { code: "BF", name: "Burkina Faso" },
    { code: "CI", name: "Côte d'Ivoire" },
    { code: "BJ", name: "Bénin" },
    { code: "SN", name: "Sénégal" },
];

const BankSettings = () => {
    const navigate = useNavigate();
    const [banks, setBanks] = useState([]);
    const [filteredBanks, setFilteredBanks] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("Tous les pays");
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [isViewEditModalOpen, setIsViewEditModalOpen] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [formValidated, setFormValidated] = useState(false);
    const [newBank, setNewBank] = useState({
        bankName: '',
        country: '',
    });
    const [searchTerm, setSearchTerm] = useState('');
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isCreating, setIsCreating] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const currentUser = JSON.parse(localStorage.getItem('user'));
    const currentUsername = currentUser ? currentUser.username : '';

    const fetchBanks = async () => {
        try {
            const response = await BankService.getAllBanks();
            setBanks(response);
            setFilteredBanks(response);
        } catch (error) {
            toast.error("Erreur lors du chargement des banques.");
        } finally {
            setIsPageLoading(false);
        }
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    const filterBanks = (country, searchTerm) => {
        setSelectedCountry(country);
        let filtered = banks;
        if (country !== "Tous les pays") {
            filtered = banks.filter((bank) => bank.country === country);
        }
        if (searchTerm) {
            filtered = filtered.filter((bank) =>
                bank.bankName.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredBanks(filtered);
    };

    const handleCreateBank = async (e) => {
        e.preventDefault();
        const form = e.target;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setFormValidated(true);
            return;
        }
        setIsCreating(true);
        try {
            const bankData = { ...newBank, userName: currentUsername };
            await BankService.createBank(bankData);
            toast.success("Banque créée avec succès !");
            setIsCreateModalOpen(false);
            setNewBank({ bankName: '', country: '' });
            fetchBanks();
        } catch (error) {
            toast.error("Erreur lors de la création de la banque.");
        } finally {
            setIsCreating(false);
        }
    };

    const handleUpdateBank = async (e) => {
        e.preventDefault();
        const form = e.target;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setFormValidated(true);
            return;
        }
        setIsUpdating(true);
        try {
            const updatedBank = { ...selectedBank, userName: currentUsername };
            await BankService.updateBank(updatedBank);
            toast.success("Banque mise à jour avec succès !");
            setIsViewEditModalOpen(false);
            setIsEditMode(false);
            fetchBanks();
        } catch (error) {
            toast.error("Erreur lors de la mise à jour de la banque.");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleDeleteBank = async (id) => {
        const confirmation = await Swal.fire({
            title: 'Êtes-vous sûr ?',
            text: "Cette action est irréversible.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer',
            cancelButtonText: 'Annuler',
        });
        if (confirmation.isConfirmed) {
            try {
                await BankService.deleteBank(id);
                toast.success("Banque supprimée avec succès !");
                fetchBanks();
            } catch (error) {
                toast.error("Erreur lors de la suppression de la banque.");
            }
        }
    };

    if (isPageLoading) {
        return <LoadingSpinner isVisible={true} loadingText="Chargement des banques..." />;
    }

    return (
        <>
            <div className="d-flex flex-column vh-100">
                <div className="flex-grow-1 overflow-y-scroll">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        <div className="verify-number-main">
                            <TopTabbar />
                            <Header />
                            <div className="verify-number-top">
                                <div className="container">
                                    <div className="verify-number-top-content">
                                        <div className="back-btn mt-32" onClick={() => navigate(-1)}>
                                            <img src="assets/svg/header-white-icon.svg" alt="back-btn" />
                                        </div>
                                        <div className="header-title mt-32">
                                            <p>Paramétrages des Banques</p>
                                        </div>
                                        <button
                                            className="btn btn-success mt-32"
                                            onClick={() => setIsCreateModalOpen(true)}
                                        >
                                            <i className="fas fa-plus me-2"></i> Ajouter une Banque
                                        </button>
                                    </div>
                                    <div className="contact-search">
                                        <div className="input-group contact-searchbar">
                                            <div className="search-icon">
                                                <img src="assets/svg/search-icon.svg" alt="search-icon" />
                                            </div>
                                            <div className="seach-bar">
                                                <input
                                                    type="search"
                                                    placeholder="Rechercher une banque"
                                                    className="form-control search-text"
                                                    id="search-input"
                                                    value={searchTerm}
                                                    onChange={(e) => {
                                                        setSearchTerm(e.target.value);
                                                        filterBanks(selectedCountry, e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="verify-number-bottom">
                                <div className="container mb-35">
                                    <div className="nav nav-tabs custom-tab-contact" role="tablist">
                                        <button
                                            className={`nav-link ${selectedCountry === "Tous les pays" ? "active" : ""}`}
                                            onClick={() => filterBanks("Tous les pays", searchTerm)}
                                        >
                                            Tous les banques
                                        </button>
                                        <Dropdown>
                                            <Dropdown.Toggle variant="link" className="nav-link dropdown-toggle">
                                                <i className="fas fa-filter me-2"></i>
                                                Filtrer
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {countries.map((country) => (
                                                    <Dropdown.Item
                                                        key={country.code}
                                                        onClick={() => filterBanks(country.name, searchTerm)}
                                                    >
                                                        <Flags code={country.code} style={{ width: "20px", marginRight: "10px" }} />
                                                        {country.name}
                                                    </Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="container" style={{ marginTop: '82px' }}>
                                    {filteredBanks.length > 0 ? (
                                        filteredBanks.map((bank) => (
                                            <div
                                                className="transfer-first d-flex align-items-center justify-content-between"
                                                key={bank.id}
                                                onClick={() => {
                                                    setSelectedBank(bank);
                                                    setIsViewEditModalOpen(true);
                                                }}
                                                style={{
                                                    transition: 'transform 0.2s',
                                                    cursor: 'pointer',
                                                    ':hover': {
                                                        transform: 'scale(1.05)',
                                                    },
                                                }}
                                            >
                                                <div className="bank-img">
                                                    <img src="assets/images/transfer-to-bank/bank1.svg" alt="bank-icon" />
                                                </div>
                                                <div className="bank-details" style={{ textAlign: 'left', width: '100%' }}>
                                                    <h2 style={{ textAlign: 'left', margin: 0 }}>{bank.bankName}</h2>
                                                    <div className="bank-card d-flex align-items-center">
                                                        <Flags
                                                            code={countries.find(c => c.name === bank.country)?.code || ""}
                                                            style={{ width: "20px", marginRight: "10px" }}
                                                        />
                                                        <span>{bank.country}</span>
                                                    </div>
                                                </div>
                                                <div className="bank-active-sec">
                                                    <FaTrashAlt
                                                        size={20}
                                                        style={{ color: "red", cursor: "pointer" }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDeleteBank(bank.id);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            <img src="assets/images/setting/no_data.png" alt="Aucun transfert"
                                                style={{ width: '100px', marginBottom: '20px' }} />
                                            <p style={{ color: '#666', fontSize: '1.2em' }}>Aucune banque trouvée</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <Footer />
                            {/* Modal de détails/édition */}
                            <Modal
                                show={isViewEditModalOpen}
                                onHide={() => setIsViewEditModalOpen(false)}
                                size="lg"
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header>
                                    <Modal.Title>
                                        {isEditMode ? 'Modifier la Banque' : 'Détails de la Banque'}
                                    </Modal.Title>
                                    {!isEditMode && (
                                        <Button
                                            variant="primary"
                                            className="ms-auto"
                                            onClick={() => setIsEditMode(!isEditMode)}
                                        >
                                            <FaEdit /> Modifier
                                        </Button>
                                    )}
                                    <Button variant="close" onClick={() => setIsViewEditModalOpen(false)} />
                                </Modal.Header>
                                <Form
                                    noValidate
                                    validated={formValidated}
                                    onSubmit={handleUpdateBank}
                                >
                                    <Modal.Body>
                                        <Form.Group controlId="bankName" className="form-floating mt-3">
                                            <Form.Control
                                                type="text"
                                                placeholder="Nom de la Banque"
                                                value={selectedBank?.bankName || ''}
                                                onChange={(e) =>
                                                    setSelectedBank({ ...selectedBank, bankName: e.target.value })
                                                }
                                                disabled={!isEditMode}
                                                required
                                            />
                                            <Form.Label>Nom de la Banque</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un nom valide.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="country" className="form-floating mt-3">
                                            <Form.Select
                                                value={selectedBank?.country || ''}
                                                onChange={(e) =>
                                                    setSelectedBank({ ...selectedBank, country: e.target.value })
                                                }
                                                disabled={!isEditMode}
                                                required
                                            >
                                                <option value="">Sélectionnez un pays</option>
                                                {countries.map((country) => (
                                                    <option key={country.code} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Pays</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un pays.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Modal.Body>
                                    {isEditMode && (
                                        <Modal.Footer>
                                            {!isUpdating && (
                                                <Button variant="secondary" onClick={() => setIsEditMode(false)}>
                                                    Annuler
                                                </Button>
                                            )}
                                            <Button variant="primary" type="submit" disabled={isUpdating}>
                                                {isUpdating ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                        <span className="visually-hidden">Chargement...</span>
                                                    </>
                                                ) : (
                                                    'Sauvegarder'
                                                )}
                                            </Button>
                                        </Modal.Footer>
                                    )}
                                </Form>
                            </Modal>
                            {/* Modal de création */}
                            <Modal
                                show={isCreateModalOpen}
                                onHide={() => setIsCreateModalOpen(false)}
                                size="lg"
                                backdrop="static"
                                keyboard={false}
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Créer une Banque</Modal.Title>
                                </Modal.Header>
                                <Form
                                    noValidate
                                    validated={formValidated}
                                    onSubmit={handleCreateBank}
                                >
                                    <Modal.Body>
                                        <Form.Group controlId="bankName" className="form-floating mt-3">
                                            <Form.Control
                                                type="text"
                                                placeholder="Nom de la Banque"
                                                value={newBank.bankName}
                                                onChange={(e) => setNewBank({ ...newBank, bankName: e.target.value })}
                                                required
                                            />
                                            <Form.Label>Nom de la Banque</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez entrer un nom valide.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group controlId="country" className="form-floating mt-3">
                                            <Form.Select
                                                value={newBank.country}
                                                onChange={(e) => setNewBank({ ...newBank, country: e.target.value })}
                                                required
                                            >
                                                <option value="">Sélectionnez un pays</option>
                                                {countries.map((country) => (
                                                    <option key={country.code} value={country.name}>
                                                        {country.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <Form.Label>Pays</Form.Label>
                                            <Form.Control.Feedback type="invalid">
                                                Veuillez sélectionner un pays.
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Modal.Body>
                                    <Modal.Footer>
                                        {!isCreating && (
                                            <Button variant="secondary" onClick={() => setIsCreateModalOpen(false)}>
                                                Annuler
                                            </Button>
                                        )}
                                        <Button variant="primary" type="submit" disabled={isCreating}>
                                            {isCreating ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    <span className="visually-hidden">Chargement...</span>
                                                </>
                                            ) : (
                                                'Ajouter'
                                            )}
                                        </Button>
                                    </Modal.Footer>
                                </Form>
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BankSettings;
